import { Box, Button, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { CustomFileUploader } from 'shared/components'
import { RESOLUTION_2275_2023 } from '../helper';

interface Props {
    relatedInvoiceNumber: string;
    nameNewsRips: string | null;
    resolution2275Document: any;
    handleChangeFile: (file: any, typeResolution: string, idDocument: string) => void;
    validateDownload: (valueCuv: string, idDocument: string) => void
    removeFile: () => void;
    idDocument: string;
    closeModal: () => void
}

export const ModalLoadRipsFiles = ({relatedInvoiceNumber, nameNewsRips, resolution2275Document, closeModal, handleChangeFile, validateDownload, removeFile, idDocument}: Props) => {
    const [valueCuv, setValueCuv] = useState<string>('');
    const typeAccept = ["JSON"];

    const handleCuv = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValueCuv(e.target.value);
    }

  return (
     <Box className='displayFlex column gap-10 padding-10'>
        <Typography className='textCustom'> Factura de referencia: <b>{relatedInvoiceNumber}</b></Typography>
        <Typography className='textCustom' data-testid='text_upload_2275'>Cargue RIPS Según Resolución 2275 mediante <b>CUV</b> y archivo <b>JSON</b></Typography>
            <Box>
                <Typography className='textLabel'>CUV</Typography>
                <TextField 
                    type="text" 
                    placeholder='Ingrese CUV' 
                    className='inputCUV' 
                    value={valueCuv}
                    onChange={handleCuv}
                />
                
            </Box>
            <Box>
                <Typography className='textLabel' data-testid='text_upload_2275'>Cargar archivo JSON</Typography>
                <CustomFileUploader 
                    fileLength={5}
                    originalName={nameNewsRips}
                    typeAccept={typeAccept}
                    document={resolution2275Document}
                    handleChangeFile={(file)=>handleChangeFile(file, RESOLUTION_2275_2023, idDocument)}
                    removeFile={removeFile}
                    isDisabled={!valueCuv}
                />
            </Box>

            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} marginTop={2} gap={2} className='buttonContainer'>
               <Button
                   variant="contained"
                   className='buttonSubmit'
                   color="primary"
                   size='large'
                   onClick={() => validateDownload(valueCuv, idDocument)}
               >
                   Cargar
               </Button>
               <Button
                   className='buttonCancelar'
                   onClick={() => closeModal()}
               >
                   Cancelar
               </Button>
            </Box>
    </Box>
  )
}
